"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _bindEvent = require("../mixins/bind-event");
var _scroll = require("../utils/scroll");
var _use = (0, _utils.use)('simple-sticky'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [(0, _bindEvent.BindEventMixin)(function (bind) {
    var _this = this;
    if (this.useSticky) return;
    if (!this.scroller) {
      this.scroller = (0, _scroll.getScrollEventTarget)(this.$el);
    }
    bind(this.scroller, 'scroll', this.onScroll, true);
    this.$nextTick(function () {
      return _this.onScroll();
    });
  })],
  props: {
    type: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom'].includes(val);
      }
    },
    zIndex: {
      type: Number,
      default: 99
    },
    useCssSticky: Boolean,
    container: null,
    offsetTop: {
      type: Number,
      default: 0
    },
    fixTop: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      fixed: false,
      height: 0,
      transform: 0
    };
  },
  computed: {
    useSticky: function useSticky() {
      if (!_utils.isServer && this.useCssSticky && window.CSS && window.CSS.supports) {
        return window.CSS.supports('position', 'sticky') ? 'sticky' : window.CSS.supports('position', '-webkit-sticky') ? '-webkit-sticky' : false;
      }
      return false;
    },
    style: function style() {
      if (this.useSticky) {
        var _ref;
        return _ref = {
          position: this.useSticky,
          zIndex: this.zIndex
        }, _ref[this.type] = this.offsetTop + "px", _ref;
      }
      if (!this.fixed) {
        return;
      }
      var style = {};
      if ((0, _utils.isDef)(this.zIndex)) {
        style.zIndex = this.zIndex;
      }
      if (this.offsetTop && this.fixed) {
        style[this.type] = this.offsetTop + "px";
      }
      if (this.transform) {
        style.transform = "translate3d(0, " + this.transform + "px, 0)";
      }
      return style;
    }
  },
  watch: {
    fixed: function fixed(val) {
      this.$emit('toggle-fixed', this.fixed);
    }
  },
  mounted: function mounted() {
    this.updateHeight();
  },
  methods: {
    updateHeight: function updateHeight() {
      if (this.$refs.sticky) {
        this.height = this.$refs.sticky.offsetHeight;
      }
    },
    onScroll: function onScroll() {
      this.updateHeight();
      if (this.type === 'bottom') {
        return this.onScrollBottom();
      }
      var container = this.container,
        offsetTop = this.offsetTop;
      var scrollTop = (0, _scroll.getScrollTop)(this.scroller);
      var topToPageTop = (0, _scroll.getElementTop)(this.$el);

      // The simple-sticky component should be kept inside the container element
      if (container) {
        var bottomToPageTop = topToPageTop + container.offsetHeight;
        if (scrollTop + offsetTop + this.height > bottomToPageTop) {
          var distanceToBottom = this.height + scrollTop - bottomToPageTop;
          if (distanceToBottom < this.height) {
            this.fixed = true;
            this.transform = -(distanceToBottom + offsetTop);
          } else {
            this.fixed = false;
          }
          return;
        }
      }
      if (scrollTop + offsetTop > (this.fixTop || topToPageTop)) {
        this.fixed = true;
        this.transform = 0;
      } else {
        this.fixed = false;
      }
    },
    onScrollBottom: function onScrollBottom() {
      var container = this.container,
        offsetTop = this.offsetTop;
      var scrollTop = (0, _scroll.getScrollTop)(this.scroller);
      var topToPageTop = (0, _scroll.getElementTop)(this.$el);

      // The simple-sticky component should be kept inside the container element
      if (container) {
        var topToPageBottom = topToPageTop + this.height - container.offsetHeight;
        if (scrollTop + window.innerHeight < topToPageBottom + offsetTop + this.height) {
          var distanceToTop = topToPageBottom - scrollTop - window.innerHeight + this.height;
          if (distanceToTop + offsetTop > 0) {
            this.fixed = true;
            this.transform = distanceToTop + offsetTop;
          } else {
            this.fixed = false;
          }
          return;
        }
      }
      if (scrollTop + window.innerHeight < topToPageTop + this.height + offsetTop) {
        this.fixed = true;
        this.transform = 0;
      } else {
        this.fixed = false;
      }
    }
  },
  render: function render() {
    var _bem;
    var h = arguments[0];
    var fixed = this.fixed,
      height = this.height,
      type = this.type;
    var style = {
      height: fixed && height ? height + "px" : undefined,
      position: 'relative'
    };
    return this.useSticky ? h("div", {
      "style": this.style
    }, [this.slots()]) : // 嵌套元素是为了保留子元素的高度
    h("div", {
      "style": style
    }, [h("div", {
      "ref": 'sticky',
      "class": bem((_bem = {}, _bem[type] = fixed, _bem)),
      "style": this.style
    }, [this.slots()])]);
  }
});
exports.default = _default;